import type { Priority } from "@app/core";
import { create } from "zustand";

/** Transient (not persisted) view filter: which priorities are selected in the
 *  sidebar. A task has exactly one priority, so there's no any/all mode — empty
 *  selection means "no filter". Read by the view-filter chain via
 *  `filterByPriorities` in lib/view-filters.ts. */
interface PriorityFilterState {
  selected: Priority[];
  toggle: (p: Priority) => void;
  clear: () => void;
}

export const usePriorityFilterStore = create<PriorityFilterState>((set, get) => ({
  selected: [],
  toggle(p) {
    const selected = get().selected;
    set({ selected: selected.includes(p) ? selected.filter((s) => s !== p) : [...selected, p] });
  },
  clear() { set({ selected: [] }); },
}));
